module.exports = __webpack_public_path__ + "static/media/Open wda-mission-of-mercy-aided-by-hjm-product-staff.174f163c.png";